import { useEffect } from "react";

/**
 * Parallax global — aplica a TODO elemento .hero__bg.
 * Data-attrs por elemento:
 *  - data-depth  (mouse, 0–0.5; default 0.05)
 *  - data-sdepth (scroll, 0–0.5; default 0.15)
 *  - data-rotate ("true"/"false"; default false)
 *  - data-max    (px do mouse, default 20)
 */
export default function ParallaxManager() {
  useEffect(() => {
    // respeita acessibilidade
    const reduced = window.matchMedia?.("(prefers-reduced-motion: reduce)")?.matches;
    if (reduced) return;

    let mx = 0, my = 0;    // mouse normalizado (-1..1)
    let sy = 0;            // scrollY
    let raf = 0;

    const items = Array.from(document.querySelectorAll(".hero__bg"));
    if (!items.length) return;

    const metas = items.map((el) => ({ el, container: el.closest(".hero") || document.documentElement }));

    const schedule = () => { if (!raf) raf = requestAnimationFrame(tick); };

    const onMouse = (e) => {
      const w = window.innerWidth || 1, h = window.innerHeight || 1;
      mx = (e.clientX - w/2) / (w/2);
      my = (e.clientY - h/2) / (h/2);
      schedule();
    };
    const onScroll = () => { sy = window.scrollY || 0; schedule(); };

    function tick() {
      raf = 0;
      metas.forEach(({ el, container }) => {
        const rect = container.getBoundingClientRect();
        const containerTop = rect.top + sy;

        const depth  = parseFloat(el.dataset.depth  ?? "0.05");
        const sdepth = parseFloat(el.dataset.sdepth ?? "0.15");
        const maxPx  = parseFloat(el.dataset.max    ?? "20");
        const rotOn  = String(el.dataset.rotate ?? "false") === "true";

        const dx = mx * maxPx * depth;
        const dyMouse = my * maxPx * depth;
        const dyScroll = -(sy - containerTop) * sdepth;

        const x = dx;
        const y = dyMouse + dyScroll;
        const rot = rotOn ? (mx * 2 * depth) : 0;

        el.style.transform = `translate3d(${x.toFixed(2)}px, ${y.toFixed(2)}px, 0) rotate(${rot.toFixed(2)}deg)`;
      });
    }

    window.addEventListener("mousemove", onMouse, { passive: true });
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll(); // primeiro frame

    return () => {
      window.removeEventListener("mousemove", onMouse);
      window.removeEventListener("scroll", onScroll);
      if (raf) cancelAnimationFrame(raf);
    };
  }, []);

  return null;
}
